import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { NewYearTree } from 'landings/new-year-tree';
import { RemoteProps } from './widgets-types';

export const NewYearTreeRemote: React.FC<RemoteProps> = ({ router, store }) => (
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <NewYearTree />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
